export default "__VITE_ASSET__Bb$pO8RQ__"